import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, Observer, Subscription } from 'rxjs';
import { filter, share, take } from 'rxjs/operators';

export class EventWithContent<T> {
    constructor(
        public name: string,
        public content?: T
    ) {}
}
/**
 * An utility class to manage RX events
 */
@Injectable({
    providedIn: 'root',
})
export class EventManager {
    observable: Observable<EventWithContent<any> | string | any>;
    observer: Observer<EventWithContent<any> | string | any>;

    constructor() {
        this.observable = new Observable((observer: Observer<EventWithContent<any> | string> | any) => {
            this.observer = observer;
        }).pipe(share());
    }

    /**
     * Method to broadcast the event to observer
     */
    broadcast(event: EventWithContent<any> | string | any): void {
        console.log('EVENT BROADCASTED', event);
        if (this.observer) {
            this.observer.next(event);
        }
    }

    httpEnd() {
        this.broadcast({
            name: 'button-clicked',
            content: {},
        });
    }

    /**
     * Method to subscribe to an event with callback
     */
    subscribe(
        eventNames: string | string[],
        callback: (event: EventWithContent<unknown> | any) => void,
        destroyRef?: DestroyRef
    ): Subscription {
        console.log('EVENT SUBSCRIBED:', eventNames);
        if (typeof eventNames == 'string') {
            eventNames = [eventNames];
        }
        const result = this.observable.pipe(
            filter((event: EventWithContent<unknown> | string) => {
                for (const eventName of eventNames) {
                    if (
                        (typeof event == 'string' && event == eventName) ||
                        (typeof event != 'string' && event.name == eventName)
                    ) {
                        return true;
                    }
                }
                return false;
            })
        );

        if (destroyRef) {
            result.pipe(destroyRef ? takeUntilDestroyed(destroyRef) : take(1));
        }
        return result.subscribe(callback);
    }

    destroy(subscriber: Subscription): void {
        subscriber.unsubscribe();
    }
}
